import React, { useState, useEffect } from 'react';
import './AgeVerificationBanner.css';

const SESSION_KEY = 'ulalaaa_age_verified';

function AgeVerificationBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem(SESSION_KEY);
    if (!verified) { setVisible(true); }
  }, []);

  const handleSi = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setVisible(false);
  };

  const handleNo = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!visible) return null;

  return (
    <div className="avb-overlay">
      <div className="avb-box">
        <div className="avb-logo-wrap">
          <img
            src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
            alt="Ulalaaa"
            className="avb-logo"
          />
        </div>
        <div className="avb-advertencia">
          <i className="fas fa-exclamation-triangle"></i> CONTENIDO EXCLUSIVO PARA ADULTOS
        </div>
        <p className="avb-texto">
          Este sitio contiene material de carácter adulto.<br />
          El acceso está <strong>estrictamente prohibido para menores de 18 años</strong>.
        </p>
        <p className="avb-pregunta">
          ¿Confirmas que eres mayor de 18 años?
        </p>
        <div className="avb-btns">
          <button className="avb-btn avb-btn-si" onClick={handleSi}>
            SÍ, SOY MAYOR DE 18 AÑOS
          </button>
          <button className="avb-btn avb-btn-no" onClick={handleNo}>
            NO, SALIR DEL SITIO
          </button>
        </div>
        <p className="avb-legal">
          Al ingresar aceptas nuestros{' '}
          <a href="/textos-legales#terminos" className="avb-link">
            Términos y Condiciones
          </a>
          {' '}y confirmas ser mayor de edad.
        </p>
      </div>
    </div>
  );
}

export default AgeVerificationBanner;
